module.exports = __webpack_public_path__ + "static/media/25-13.c5e32097.mp3";